@if (fiat !== null && max === null) {
  <div
    class="fiat-amount-tile"
    [ngClass]="{ 'recurring-height': isSavings }"
    (keydown.enter)="anchorBig.click()"
    [tabIndex]="0">
    <div class="fiat-amount-tile-amount-container">
      <div class="fiat-amount-tile-amount-big">
        <a #anchorBig href="javascript:;" [tabIndex]="-1">
          {{ amount | fiat_precision_symbol: { id: fiat?.getId(), symbol: isSavings, currencies: [fiat] } }}
        </a>
      </div>
    </div>
  </div>
}
@if (max !== null) {
  <div
    class="fiat-amount-tile"
    [ngClass]="{ 'recurring-height': isSavings }"
    (keydown.enter)="anchorMax.click()"
    [tabIndex]="0">
    <div class="fiat-amount-tile-amount-container">
      <div class="fiat-amount-tile-amount-big">
        <a #anchorMax href="javascript:;" [tabIndex]="-1">{{ max }}</a>
      </div>
      <div class="fiat-amount-tile-amount-small">
        {{ amount | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat], symbol: isSavings } }}
        @if (isSavings) {
          <span>
            ({{ "recurring_buy_modal_frequency_main_" + recurringFrequency | translate }})
          </span>
        }
      </div>
    </div>
  </div>
}
